import { render, staticRenderFns } from "./professionalTownDetail.vue?vue&type=template&id=25d74b76&scoped=true&"
import script from "./professionalTownDetail.vue?vue&type=script&lang=js&"
export * from "./professionalTownDetail.vue?vue&type=script&lang=js&"
import style0 from "./professionalTownDetail.vue?vue&type=style&index=0&id=25d74b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d74b76",
  null
  
)

export default component.exports